export default __webpack_public_path__ + "static/media/NW-20-SL_license_02214_04.24.20.cecd9292.pdf";